import { render, staticRenderFns } from "./v-content.vue?vue&type=template&id=66996e36&"
import script from "./v-content.vue?vue&type=script&lang=js&"
export * from "./v-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports